import { HttpContext, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { siQuoteUrls } from "../../../environments/environment";
import { CancelOrUnlockReviewRequest, CancelOrUnlockReviewResponse, CostReviewOpenRequest, CostReviewOpenResponse, PolicyMandatedApproverRequest, PolicyMandatedApproverResponse, RefreshReviewRequest, RefreshReviewResponse, 
  ReviewerVerificationRequest, SendReviewOrReplaceReviewerRequest, SendReviewOrReplaceReviewerResponse, UserCostReviewThresholdRequest, UserCostReviewThresholdResponse, VerifyCostReviewerResponse } from "../../models/dtos";
import { CostReviewParameters } from "../../models/common/CostReviewParameter";
import { BaseHttpService } from "./base-http.service";
import { withLocalErrorHandling } from "../../core/errors/http-context-tokens";
import { CULTURE_ID } from "../../models/enum";

@Injectable({
  providedIn: 'root'
})
export class GetReviewDetailsService {

  constructor(private readonly baseHttp: BaseHttpService) { }
  
  getPolicyMandatedApprovers(requestBody: PolicyMandatedApproverRequest): Observable<PolicyMandatedApproverResponse> {
    return this.baseHttp.post<PolicyMandatedApproverResponse>(`${siQuoteUrls.costReview}/GetPolicyMandatedApprovers`, requestBody);
  }
  
  getReviewDetails(requestBody: CostReviewOpenRequest): Observable<CostReviewOpenResponse> {
    return this.baseHttp.post<CostReviewOpenResponse>(`${siQuoteUrls.costReview}/GetReviewDetails`, requestBody);
  }

  getCostReviewParameterData(cultureId: number): Observable<CostReviewParameters[]> {
    const context: HttpContext = withLocalErrorHandling();
    const params = new HttpParams().set('cultureId', cultureId.toString());
    let cultureName: string;
    if(cultureId === CULTURE_ID.EN_US) {
      cultureName = 'en-US';
    }
    else if(cultureId === CULTURE_ID.FR_CA) {
      cultureName = 'fr-CA';
    }
    else {
      cultureName = 'en-CA';
    }
    return this.baseHttp.get<CostReviewParameters[]>(`static-data/CostReviewParams-culture_${cultureName}-static.json`, params, { context });
  }

  verifyCostReviewer(requestBody: ReviewerVerificationRequest): Observable<VerifyCostReviewerResponse> {
    return this.baseHttp.post<VerifyCostReviewerResponse>(`${siQuoteUrls.costReview}/VerifyCostReviewer`, requestBody);
  }

  sendReviewOrReplaceReviewer(requestBody: SendReviewOrReplaceReviewerRequest): Observable<SendReviewOrReplaceReviewerResponse> {
    const context: HttpContext = withLocalErrorHandling();
    return this.baseHttp.post<SendReviewOrReplaceReviewerResponse>(`${siQuoteUrls.costReview}/SendReviewOrReplaceReviewer`, requestBody, { context });
  }

  cancelOrUnlockCostReview(requestBody: CancelOrUnlockReviewRequest, suppressGlobalError: boolean = false): Observable<CancelOrUnlockReviewResponse> {
    const context: HttpContext = suppressGlobalError ? withLocalErrorHandling() : undefined;
    return this.baseHttp.post<CancelOrUnlockReviewResponse>(`${siQuoteUrls.costReview}/CancelOrUnlockReview`, requestBody, { context });
  }

  refreshCostReview(requestBody: RefreshReviewRequest): Observable<RefreshReviewResponse> {
    return this.baseHttp.post<RefreshReviewResponse>(`${siQuoteUrls.costReview}/RefreshReview`, requestBody);
  }

  getUserCostReviewThreshold(requestBody: UserCostReviewThresholdRequest): Observable<UserCostReviewThresholdResponse> {
      return this.baseHttp.post<UserCostReviewThresholdResponse>(`${siQuoteUrls.costReview}/GetUserCostReviewThreshold`, requestBody);
  }
}